import { serviceSlice } from "./slice";

export const { handleEdit, handleAddNewService } = serviceSlice.actions 

export default serviceSlice.reducer;
